import { OwnerType, SupplierStatus } from '../constants/commonConstants';

export const checkIsInternalSourcing= (user) => {
    let userType=user?.toLowerCase();
    return userType === OwnerType.INTERNAL_SOURCE.toLowerCase();
}

export const checkIsFleetOwner= (user) => {
    let userType=user?.toLowerCase();
    return userType === OwnerType.FLEET_OWNER.toLowerCase();
}

export const checkIsFleetOwnerOrBroker= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.FLEET_OWNER.toLowerCase()||userType === OwnerType.BROKER.toLowerCase();
}

export const checkIsSTOorBroker= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.STO.toLowerCase() || userType === OwnerType.BROKER.toLowerCase();
}

export const checkIsSTO= (user) => {
    let userType=user?.toLowerCase();
    return userType === OwnerType.STO.toLowerCase();
}

export const checkIsBroker= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.BROKER.toLowerCase();
}
export const checkIsFleetOwnerConverted= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.FLEET_OWNER_C.toLowerCase();
}

export const checkIsTurkeyKazak=(country)=>{
    let countries=["turkey","kazakhstan"];
    let lowerCaseCountry=country?.toLowerCase();
    return countries.some(x=>x===lowerCaseCountry);
}

export const checkIsCountryPresent=(country)=>{
    let countries=["united arab emirates","saudi arabia",'bahrain','oman','jordan','egypt','kuwait','yemen'];
    let lowerCaseCountry=country?.toLowerCase();
    return countries.some(x=>x===lowerCaseCountry);
}

export const checkIsGCCCountry=(country)=>{
  let countries=["united arab emirates","saudi arabia",'bahrain','oman'];
  let lowerCaseCountry=country?.toLowerCase();
  return countries.some(x=>x===lowerCaseCountry);
}
export const getCurrencyCode = (country) => {
    switch (country) {
      case "United Arab Emirates":
        return "AED";
      case "Saudi Arabia":
        return "SAR";
      case "Bahrain":
        return "BHD";
      case "Turkey":
        return "TL";
      case "Oman":
        return "OMR";
      case "Jordan":
        return "JOD";
      case "Kazakhstan":
        return "KZK";
      case "Egypt":
        return "EGP";
      case "Poland":
        return "POL";
      case "India":
        return "INR";
      default:
        return "";
    }
};

export const checkIsDetailsPending= (userStatus) => {
  return userStatus === SupplierStatus.DETAILS_PENDING;
}

export const checkIsDetailsSubmitted= (userStatus) => {
  return userStatus === SupplierStatus.DETAILS_SUBMITTED;
}

export const checkIsDetailsPendingSubmitted= (userStatus) => {
  let status=(userStatus === SupplierStatus.DETAILS_PENDING || userStatus === SupplierStatus.DETAILS_SUBMITTED || userStatus === SupplierStatus.DETAILS_BANNED);
  return status;
}

export const checkIsDetailsBanned= (userStatus) => {
  return userStatus === SupplierStatus.DETAILS_BANNED;
}

export const checkIsBlocked= (userStatus) => {
  return userStatus === SupplierStatus.BLOCKED;
}

export const checkIsUAEOperatingCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='united arab emirates' || userCountry === 'uae');
}

export const checkIsKSAOperatingCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='saudi arabia' || userCountry === 'ksa');
}

export const maskPhoneNumber = (number) => {
  if (!number) return "";

  const cleaned = number.replace(/\s+/g, "");

  if (cleaned.length <= 6) return "XXXXXX";

  const visiblePart = cleaned.slice(0, cleaned.length - 6);
  return visiblePart + "XXXXXX";
};

export const checkIsPricingUnitTrucks= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit ==='truck' || localPricingUnit === 'trucks');
}

export const checkIsPricingUnitTons= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit ==='ton' || localPricingUnit === 'tons');
}

export const checkIsPricingUnitKMs= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit ==='km' || localPricingUnit === 'kms');
}

export const checkIsPricingUnitMiles= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit === 'mile' || localPricingUnit === 'miles');
}

export const checkIsPricingUnitKGs= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit === 'kg' || localPricingUnit === 'kgs');
}

export const checkIsNewInquiryFlow= (hasBid,isMultiBiddingFlow) => {
     if(hasBid && !isMultiBiddingFlow){
      return false;
      }else{
      return true;
      }
    }
    
export const checkIsOMANOperatingCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='oman' || userCountry === 'omn');
}


export const removeUniquenessCheckForCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='saudi arabia' || userCountry === 'ksa' || userCountry ==='oman' || userCountry === 'omn' || 
           userCountry ==='turkey' || userCountry ==='tur' || userCountry ==='bahrain' || 
           userCountry ==='bhr' || userCountry ==='egypt' || userCountry ==='egp');
}


